export const customerTranslations = {
  en: {
    'common.name': 'Name',
    'common.email': 'Email',
    'common.password': 'Password',
    'common.role': 'Role',
    'common.notSet': 'Not set',
    'common.loading': 'Loading...',
    'common.refresh': 'Refresh',
    'common.default': 'Default',
    'common.quantity': 'Quantity: {{quantity}}',
    'common.price': 'Price: {{price}}',
    'auth.login.seoDescription': 'Log in to your YCH-YOYO account.',
    'auth.login.intro': 'Access your YCH-YOYO account with your email and password.',
    'auth.login.submitting': 'Logging in...',
    'auth.login.error': 'Unable to log in.',
    'auth.login.newUser': 'New to YCH-YOYO?',
    'auth.createAccount': 'Create an account',
    'auth.register.title': 'Create Account',
    'auth.register.seoDescription': 'Create a YCH-YOYO customer account.',
    'auth.register.intro': 'Use an email and password to create your YCH-YOYO account.',
    'auth.register.submitting': 'Creating account...',
    'auth.register.error': 'Unable to create account.',
    'auth.register.existingUser': 'Already have an account?',
    'account.seoDescription': 'YCH-YOYO account page.',
    'account.loading': 'Loading your account...',
    'account.signedOutPrompt': 'Login or create an account to access your YCH-YOYO profile and orders.',
    'account.active': 'Your YCH-YOYO account is active.',
    'account.role.customer': 'Customer',
    'account.role.admin': 'Administrator',
    'account.role.unknown': 'Account role unavailable',
    'account.continueShopping': 'Continue shopping',
    'account.customProjects': 'Custom projects',
    'account.orders.title': 'My Orders',
    'account.orders.intro': 'View paid orders, custom yo-yo artwork, and shipment tracking.',
    'account.orders.loadError': 'Failed to load orders.',
    'account.orders.empty': 'No orders found yet.',
    'account.orderStatus.pending': 'Pending',
    'account.orderStatus.processing': 'Processing',
    'account.orderStatus.paid': 'Paid',
    'account.orderStatus.completed': 'Completed',
    'account.orderStatus.cancelled': 'Cancelled',
    'account.orderStatus.failed': 'Failed',
    'account.orderStatus.refunded': 'Refunded',
    'account.orderStatus.unknown': 'Status unavailable',
    'account.orderId': 'Order ID',
    'account.paid': 'Paid: {{date}}',
    'account.country': 'Country: {{country}}',
    'account.shipment': 'Shipment',
    'account.shipment.delivered': 'Delivered',
    'account.shipment.shipped': 'Shipped',
    'account.shipment.preparing': 'Preparing shipment',
    'account.trackingNumber': '{{carrier}} tracking number',
    'account.trackingPending': 'We will update the tracking number after shipment.',
    'account.trackYanwen': 'Track with Yanwen',
    'account.originalArtwork': 'Original Artwork',
    'account.adjustedPreview': 'Adjusted Preview',
    'account.originalArtworkAlt': 'Customer original artwork',
    'account.adjustedPreviewAlt': 'Adjusted custom yo-yo preview',
    'cart.seoDescription': 'Shopping cart for YCH-YOYO checkout.',
    'cart.title': 'Your Cart',
    'cart.empty': 'No items in cart.',
    'cart.artworkAfterPayment': 'Artwork upload unlocks after payment.',
    'cart.decreaseQuantity': 'Decrease quantity for {{item}}',
    'cart.increaseQuantity': 'Increase quantity for {{item}}',
    'cart.remove': 'Remove',
    'cart.total': 'Total: {{total}}',
    'cart.countryLabel': 'Choose your country/region:',
    'cart.countrySelect': 'Select',
    'cart.checkout': 'Checkout',
    'cart.checkoutError': 'Checkout failed. Please try again.',
    'cart.unlistedCountry': 'If your country or region is not listed above, please contact us directly.',
    'cart.loginRequired': 'Log in required',
    'cart.loginPrompt': 'Please log in or create an account before checking out.',
    'payment.seoDescription': 'Secure checkout for YCH-YOYO orders.',
    'payment.succeeded': 'Payment succeeded!',
    'payment.processing': 'Your payment is processing.',
    'payment.failed': 'Your payment was not successful. Please try again.',
    'payment.error': 'Something went wrong.',
    'payment.unexpectedError': 'An unexpected error occurred.',
    'payment.payNow': 'Pay now',
    'contact.title': 'Contact YCH-YOYO',
    'contact.seoTitle': 'Contact Us',
    'contact.seoDescription': 'Contact YCH-YOYO for support, product questions, and general inquiries.',
    'contact.intro': 'Fill out this form if you need help or have a general question.',
    'contact.firstName': 'First Name (required)',
    'contact.lastName': 'Last Name (required)',
    'contact.email': 'Email Address (required)',
    'contact.subject': 'Subject (required)',
    'contact.message': 'Message (required)',
    'contact.submit': 'Submit',
    'shipping.seoTitle': 'Shipping Policy',
    'shipping.seoDescription': 'Shipping coverage, delivery timing notes, and currency information for YCH-YOYO orders.',
    'shipping.title': 'Shipping Information',
    'shipping.intro': 'YCH-YOYO is a global yo-yo shop and ships to most destinations supported in checkout. If your country or region is not listed, please contact us before ordering.',
    'shipping.timingTitle': 'Delivery Timing',
    'shipping.timing': 'Shipping time depends on destination, customs, and local carrier performance. Estimated timing is shown during checkout when available.',
    'shipping.carrierTitle': 'Shipping Carrier',
    'shipping.carrier': 'Carrier service may vary by destination and parcel type.',
    'shipping.currencyTitle': 'Currency',
    'shipping.currency': 'All listed product prices are in USD.',
    'shipping.questionsTitle': 'Policy Questions',
    'shipping.questions': 'For shipping, returns, or special handling requests, please use the contact form.',
    'shipping.faq.where.question': 'Where does YCH-YOYO ship?',
    'shipping.faq.where.answer': 'YCH-YOYO serves international customers and supports shipping to most regions available in checkout.',
    'shipping.faq.time.question': 'How long does shipping usually take?',
    'shipping.faq.time.answer': 'Delivery time varies by destination and customs processing. The final timeline is confirmed after checkout.',
    'shipping.faq.currency.question': 'What currency is used on the store?',
    'shipping.faq.currency.answer': 'All product prices on ych-yoyo.com are listed in USD.',
    'notFound.seoTitle': 'Page Not Found',
    'notFound.seoDescription': 'The page you are looking for does not exist.',
    'notFound.title': '404 - Page Not Found',
    'notFound.message': 'The requested page does not exist or has moved.',
    'notFound.store': 'Go to Store',
  },
  ja: {
    'common.name': '名前',
    'common.email': 'メールアドレス',
    'common.password': 'パスワード',
    'common.role': '役割',
    'common.notSet': '未設定',
    'common.loading': '読み込み中...',
    'common.refresh': '更新',
    'common.default': 'デフォルト',
    'common.quantity': '数量：{{quantity}}',
    'common.price': '価格：{{price}}',
    'auth.login.seoDescription': 'YCH-YOYOアカウントにログインします。',
    'auth.login.intro': 'メールアドレスとパスワードでYCH-YOYOアカウントにアクセスできます。',
    'auth.login.submitting': 'ログイン中...',
    'auth.login.error': 'ログインできませんでした。',
    'auth.login.newUser': 'YCH-YOYOを初めてご利用ですか？',
    'auth.createAccount': 'アカウントを作成',
    'auth.register.title': 'アカウント作成',
    'auth.register.seoDescription': 'YCH-YOYOのお客様アカウントを作成します。',
    'auth.register.intro': 'メールアドレスとパスワードを使ってYCH-YOYOアカウントを作成します。',
    'auth.register.submitting': 'アカウントを作成中...',
    'auth.register.error': 'アカウントを作成できませんでした。',
    'auth.register.existingUser': 'すでにアカウントをお持ちですか？',
    'account.seoDescription': 'YCH-YOYOアカウントページ。',
    'account.loading': 'アカウントを読み込み中...',
    'account.signedOutPrompt': 'ログインまたはアカウントを作成すると、プロフィールと注文履歴を確認できます。',
    'account.active': 'YCH-YOYOアカウントは有効です。',
    'account.role.customer': 'お客様',
    'account.role.admin': '管理者',
    'account.role.unknown': 'アカウント種別不明',
    'account.continueShopping': '買い物を続ける',
    'account.customProjects': 'カスタムプロジェクト',
    'account.orders.title': '注文履歴',
    'account.orders.intro': '支払い済みの注文、カスタムヨーヨーのアートワーク、配送状況を確認できます。',
    'account.orders.loadError': '注文を読み込めませんでした。',
    'account.orders.empty': '注文はまだありません。',
    'account.orderStatus.pending': '保留中',
    'account.orderStatus.processing': '処理中',
    'account.orderStatus.paid': '支払い済み',
    'account.orderStatus.completed': '完了',
    'account.orderStatus.cancelled': 'キャンセル済み',
    'account.orderStatus.failed': '失敗',
    'account.orderStatus.refunded': '返金済み',
    'account.orderStatus.unknown': 'ステータス不明',
    'account.orderId': '注文ID',
    'account.paid': '支払日時：{{date}}',
    'account.country': '国・地域：{{country}}',
    'account.shipment': '配送',
    'account.shipment.delivered': '配達済み',
    'account.shipment.shipped': '発送済み',
    'account.shipment.preparing': '発送準備中',
    'account.trackingNumber': '{{carrier}} 追跡番号',
    'account.trackingPending': '発送後に追跡番号を更新します。',
    'account.trackYanwen': 'Yanwenで追跡',
    'account.originalArtwork': '元のアートワーク',
    'account.adjustedPreview': '調整後プレビュー',
    'account.originalArtworkAlt': 'お客様がアップロードした元のアートワーク',
    'account.adjustedPreviewAlt': '調整後のカスタムヨーヨープレビュー',
    'cart.seoDescription': 'YCH-YOYOのショッピングカート。',
    'cart.title': 'カート',
    'cart.empty': 'カートに商品はありません。',
    'cart.artworkAfterPayment': 'お支払い後にアートワークをアップロードできます。',
    'cart.decreaseQuantity': '{{item}}の数量を減らす',
    'cart.increaseQuantity': '{{item}}の数量を増やす',
    'cart.remove': '削除',
    'cart.total': '合計：{{total}}',
    'cart.countryLabel': '国・地域を選択：',
    'cart.countrySelect': '選択してください',
    'cart.checkout': '購入手続きへ',
    'cart.checkoutError': '購入手続きに失敗しました。もう一度お試しください。',
    'cart.unlistedCountry': 'お住まいの国・地域が一覧にない場合は、直接お問い合わせください。',
    'cart.loginRequired': 'ログインが必要です',
    'cart.loginPrompt': '購入手続きの前にログインするか、アカウントを作成してください。',
    'payment.seoDescription': 'YCH-YOYO注文の安全な決済ページ。',
    'payment.succeeded': 'お支払いが完了しました。',
    'payment.processing': 'お支払いを処理しています。',
    'payment.failed': 'お支払いが完了しませんでした。もう一度お試しください。',
    'payment.error': '問題が発生しました。',
    'payment.unexpectedError': '予期しないエラーが発生しました。',
    'payment.payNow': '今すぐ支払う',
    'contact.title': 'YCH-YOYOへのお問い合わせ',
    'contact.seoTitle': 'お問い合わせ',
    'contact.seoDescription': 'サポート、商品、ご質問についてYCH-YOYOへお問い合わせください。',
    'contact.intro': 'サポートが必要な場合やご質問がある場合は、このフォームをご利用ください。',
    'contact.firstName': '名（必須）',
    'contact.lastName': '姓（必須）',
    'contact.email': 'メールアドレス（必須）',
    'contact.subject': '件名（必須）',
    'contact.message': 'メッセージ（必須）',
    'contact.submit': '送信',
    'shipping.seoTitle': '配送ポリシー',
    'shipping.seoDescription': 'YCH-YOYO注文の配送地域、所要時間、通貨についてご案内します。',
    'shipping.title': '配送情報',
    'shipping.intro': 'YCH-YOYOは世界各地にヨーヨーを発送しています。購入手続きで選択できるほとんどの地域に配送可能です。国・地域が一覧にない場合は、ご注文前にお問い合わせください。',
    'shipping.timingTitle': '配送期間',
    'shipping.timing': '配送期間は、配送先、通関、現地配送業者の状況により異なります。利用可能な場合は購入手続き中に目安を表示します。',
    'shipping.carrierTitle': '配送業者',
    'shipping.carrier': '配送業者は、配送先と荷物の種類によって異なる場合があります。',
    'shipping.currencyTitle': '通貨',
    'shipping.currency': '表示されている商品価格はすべて米ドルです。',
    'shipping.questionsTitle': 'ポリシーに関するお問い合わせ',
    'shipping.questions': '配送、返品、特別な取り扱いについては、お問い合わせフォームをご利用ください。',
    'shipping.faq.where.question': 'YCH-YOYOはどこに配送しますか？',
    'shipping.faq.where.answer': 'YCH-YOYOは海外のお客様にも対応し、購入手続きで選択できるほとんどの地域に配送します。',
    'shipping.faq.time.question': '配送には通常どのくらいかかりますか？',
    'shipping.faq.time.answer': '配送期間は配送先と通関手続きによって異なります。最終的な予定は購入手続き後に確定します。',
    'shipping.faq.currency.question': 'ストアではどの通貨を使用しますか？',
    'shipping.faq.currency.answer': 'ych-yoyo.comの商品価格はすべて米ドルで表示されます。',
    'notFound.seoTitle': 'ページが見つかりません',
    'notFound.seoDescription': 'お探しのページは存在しません。',
    'notFound.title': '404 - ページが見つかりません',
    'notFound.message': '指定されたページは存在しないか、移動しました。',
    'notFound.store': 'ストアへ移動',
  },
  'zh-CN': {
    'common.name': '姓名',
    'common.email': '电子邮箱',
    'common.password': '密码',
    'common.role': '角色',
    'common.notSet': '未设置',
    'common.loading': '加载中...',
    'common.refresh': '刷新',
    'common.default': '默认',
    'common.quantity': '数量：{{quantity}}',
    'common.price': '价格：{{price}}',
    'auth.login.seoDescription': '登录您的 YCH-YOYO 账户。',
    'auth.login.intro': '使用电子邮箱和密码访问您的 YCH-YOYO 账户。',
    'auth.login.submitting': '正在登录...',
    'auth.login.error': '无法登录。',
    'auth.login.newUser': '第一次使用 YCH-YOYO？',
    'auth.createAccount': '创建账户',
    'auth.register.title': '创建账户',
    'auth.register.seoDescription': '创建 YCH-YOYO 客户账户。',
    'auth.register.intro': '使用电子邮箱和密码创建您的 YCH-YOYO 账户。',
    'auth.register.submitting': '正在创建账户...',
    'auth.register.error': '无法创建账户。',
    'auth.register.existingUser': '已有账户？',
    'account.seoDescription': 'YCH-YOYO 账户页面。',
    'account.loading': '正在加载账户...',
    'account.signedOutPrompt': '请登录或创建账户，以查看您的 YCH-YOYO 个人资料和订单。',
    'account.active': '您的 YCH-YOYO 账户已激活。',
    'account.role.customer': '客户',
    'account.role.admin': '管理员',
    'account.role.unknown': '账户角色不可用',
    'account.continueShopping': '继续购物',
    'account.customProjects': '定制项目',
    'account.orders.title': '我的订单',
    'account.orders.intro': '查看已付款订单、定制悠悠球图稿和物流追踪。',
    'account.orders.loadError': '无法加载订单。',
    'account.orders.empty': '暂时没有订单。',
    'account.orderStatus.pending': '待处理',
    'account.orderStatus.processing': '处理中',
    'account.orderStatus.paid': '已付款',
    'account.orderStatus.completed': '已完成',
    'account.orderStatus.cancelled': '已取消',
    'account.orderStatus.failed': '失败',
    'account.orderStatus.refunded': '已退款',
    'account.orderStatus.unknown': '状态不可用',
    'account.orderId': '订单编号',
    'account.paid': '付款时间：{{date}}',
    'account.country': '国家或地区：{{country}}',
    'account.shipment': '物流',
    'account.shipment.delivered': '已送达',
    'account.shipment.shipped': '已发货',
    'account.shipment.preparing': '备货中',
    'account.trackingNumber': '{{carrier}} 物流单号',
    'account.trackingPending': '发货后我们会更新物流单号。',
    'account.trackYanwen': '前往燕文物流查询',
    'account.originalArtwork': '原始图稿',
    'account.adjustedPreview': '调整后预览',
    'account.originalArtworkAlt': '客户原始图稿',
    'account.adjustedPreviewAlt': '调整后的定制悠悠球预览',
    'cart.seoDescription': 'YCH-YOYO 结账购物车。',
    'cart.title': '您的购物车',
    'cart.empty': '购物车中没有商品。',
    'cart.artworkAfterPayment': '付款后即可上传图稿。',
    'cart.decreaseQuantity': '减少 {{item}} 的数量',
    'cart.increaseQuantity': '增加 {{item}} 的数量',
    'cart.remove': '移除',
    'cart.total': '合计：{{total}}',
    'cart.countryLabel': '选择您的国家或地区：',
    'cart.countrySelect': '请选择',
    'cart.checkout': '结账',
    'cart.checkoutError': '结账失败，请重试。',
    'cart.unlistedCountry': '如果上方没有您的国家或地区，请直接联系我们。',
    'cart.loginRequired': '需要登录',
    'cart.loginPrompt': '请先登录或创建账户，然后再结账。',
    'payment.seoDescription': 'YCH-YOYO 订单安全结账页面。',
    'payment.succeeded': '付款成功！',
    'payment.processing': '正在处理您的付款。',
    'payment.failed': '付款未成功，请重试。',
    'payment.error': '出现问题。',
    'payment.unexpectedError': '发生意外错误。',
    'payment.payNow': '立即付款',
    'contact.title': '联系 YCH-YOYO',
    'contact.seoTitle': '联系我们',
    'contact.seoDescription': '联系 YCH-YOYO，咨询支持、产品和其他问题。',
    'contact.intro': '如需帮助或有一般问题，请填写此表单。',
    'contact.firstName': '名字（必填）',
    'contact.lastName': '姓氏（必填）',
    'contact.email': '电子邮箱（必填）',
    'contact.subject': '主题（必填）',
    'contact.message': '留言（必填）',
    'contact.submit': '提交',
    'shipping.seoTitle': '配送政策',
    'shipping.seoDescription': '了解 YCH-YOYO 订单的配送范围、时效和结算货币。',
    'shipping.title': '配送信息',
    'shipping.intro': 'YCH-YOYO 面向全球销售悠悠球，可配送至结账页面支持的大多数目的地。如果列表中没有您的国家或地区，请在订购前联系我们。',
    'shipping.timingTitle': '配送时效',
    'shipping.timing': '配送时间取决于目的地、清关和当地承运商的效率。如有预计时效，将在结账时显示。',
    'shipping.carrierTitle': '承运商',
    'shipping.carrier': '承运服务可能因目的地和包裹类型而异。',
    'shipping.currencyTitle': '结算货币',
    'shipping.currency': '所有商品标价均为美元。',
    'shipping.questionsTitle': '政策咨询',
    'shipping.questions': '如需咨询配送、退货或特殊处理要求，请使用联系表单。',
    'shipping.faq.where.question': 'YCH-YOYO 配送到哪些地区？',
    'shipping.faq.where.answer': 'YCH-YOYO 服务国际客户，可配送至结账页面支持的大多数地区。',
    'shipping.faq.time.question': '配送通常需要多长时间？',
    'shipping.faq.time.answer': '配送时间取决于目的地和清关进度，最终时间将在结账后确认。',
    'shipping.faq.currency.question': '商店使用什么货币？',
    'shipping.faq.currency.answer': 'ych-yoyo.com 的所有商品价格均以美元标示。',
    'notFound.seoTitle': '找不到页面',
    'notFound.seoDescription': '您要查找的页面不存在。',
    'notFound.title': '404 - 找不到页面',
    'notFound.message': '请求的页面不存在或已移动。',
    'notFound.store': '前往商店',
  },
  'zh-TW': {
    'common.name': '姓名',
    'common.email': '電子郵件',
    'common.password': '密碼',
    'common.role': '角色',
    'common.notSet': '未設定',
    'common.loading': '載入中...',
    'common.refresh': '重新整理',
    'common.default': '預設',
    'common.quantity': '數量：{{quantity}}',
    'common.price': '價格：{{price}}',
    'auth.login.seoDescription': '登入您的 YCH-YOYO 帳戶。',
    'auth.login.intro': '使用電子郵件和密碼存取您的 YCH-YOYO 帳戶。',
    'auth.login.submitting': '登入中...',
    'auth.login.error': '無法登入。',
    'auth.login.newUser': '第一次使用 YCH-YOYO？',
    'auth.createAccount': '建立帳戶',
    'auth.register.title': '建立帳戶',
    'auth.register.seoDescription': '建立 YCH-YOYO 客戶帳戶。',
    'auth.register.intro': '使用電子郵件和密碼建立您的 YCH-YOYO 帳戶。',
    'auth.register.submitting': '正在建立帳戶...',
    'auth.register.error': '無法建立帳戶。',
    'auth.register.existingUser': '已有帳戶？',
    'account.seoDescription': 'YCH-YOYO 帳戶頁面。',
    'account.loading': '正在載入帳戶...',
    'account.signedOutPrompt': '請登入或建立帳戶，以查看您的 YCH-YOYO 個人資料和訂單。',
    'account.active': '您的 YCH-YOYO 帳戶已啟用。',
    'account.role.customer': '客戶',
    'account.role.admin': '管理員',
    'account.role.unknown': '帳戶角色無法取得',
    'account.continueShopping': '繼續購物',
    'account.customProjects': '客製專案',
    'account.orders.title': '我的訂單',
    'account.orders.intro': '查看已付款訂單、客製溜溜球圖稿和物流追蹤。',
    'account.orders.loadError': '無法載入訂單。',
    'account.orders.empty': '目前沒有訂單。',
    'account.orderStatus.pending': '待處理',
    'account.orderStatus.processing': '處理中',
    'account.orderStatus.paid': '已付款',
    'account.orderStatus.completed': '已完成',
    'account.orderStatus.cancelled': '已取消',
    'account.orderStatus.failed': '失敗',
    'account.orderStatus.refunded': '已退款',
    'account.orderStatus.unknown': '狀態無法取得',
    'account.orderId': '訂單編號',
    'account.paid': '付款時間：{{date}}',
    'account.country': '國家或地區：{{country}}',
    'account.shipment': '物流',
    'account.shipment.delivered': '已送達',
    'account.shipment.shipped': '已出貨',
    'account.shipment.preparing': '備貨中',
    'account.trackingNumber': '{{carrier}} 物流單號',
    'account.trackingPending': '出貨後我們會更新物流單號。',
    'account.trackYanwen': '前往燕文物流查詢',
    'account.originalArtwork': '原始圖稿',
    'account.adjustedPreview': '調整後預覽',
    'account.originalArtworkAlt': '客戶原始圖稿',
    'account.adjustedPreviewAlt': '調整後的客製溜溜球預覽',
    'cart.seoDescription': 'YCH-YOYO 結帳購物車。',
    'cart.title': '您的購物車',
    'cart.empty': '購物車中沒有商品。',
    'cart.artworkAfterPayment': '付款後即可上傳圖稿。',
    'cart.decreaseQuantity': '減少 {{item}} 的數量',
    'cart.increaseQuantity': '增加 {{item}} 的數量',
    'cart.remove': '移除',
    'cart.total': '合計：{{total}}',
    'cart.countryLabel': '選擇您的國家或地區：',
    'cart.countrySelect': '請選擇',
    'cart.checkout': '結帳',
    'cart.checkoutError': '結帳失敗，請再試一次。',
    'cart.unlistedCountry': '如果上方沒有您的國家或地區，請直接聯絡我們。',
    'cart.loginRequired': '需要登入',
    'cart.loginPrompt': '請先登入或建立帳戶，然後再結帳。',
    'payment.seoDescription': 'YCH-YOYO 訂單安全結帳頁面。',
    'payment.succeeded': '付款成功！',
    'payment.processing': '正在處理您的付款。',
    'payment.failed': '付款未成功，請再試一次。',
    'payment.error': '發生問題。',
    'payment.unexpectedError': '發生非預期的錯誤。',
    'payment.payNow': '立即付款',
    'contact.title': '聯絡 YCH-YOYO',
    'contact.seoTitle': '聯絡我們',
    'contact.seoDescription': '聯絡 YCH-YOYO，洽詢支援、產品和其他問題。',
    'contact.intro': '如需協助或有一般問題，請填寫此表單。',
    'contact.firstName': '名字（必填）',
    'contact.lastName': '姓氏（必填）',
    'contact.email': '電子郵件（必填）',
    'contact.subject': '主旨（必填）',
    'contact.message': '留言（必填）',
    'contact.submit': '送出',
    'shipping.seoTitle': '配送政策',
    'shipping.seoDescription': '瞭解 YCH-YOYO 訂單的配送範圍、時效和結算貨幣。',
    'shipping.title': '配送資訊',
    'shipping.intro': 'YCH-YOYO 面向全球銷售溜溜球，可配送至結帳頁面支援的大多數目的地。如果清單中沒有您的國家或地區，請在訂購前聯絡我們。',
    'shipping.timingTitle': '配送時效',
    'shipping.timing': '配送時間取決於目的地、清關和當地承運商的效率。如有預估時效，將在結帳時顯示。',
    'shipping.carrierTitle': '承運商',
    'shipping.carrier': '承運服務可能因目的地和包裹類型而異。',
    'shipping.currencyTitle': '結算貨幣',
    'shipping.currency': '所有商品標價均為美元。',
    'shipping.questionsTitle': '政策諮詢',
    'shipping.questions': '如需諮詢配送、退貨或特殊處理要求，請使用聯絡表單。',
    'shipping.faq.where.question': 'YCH-YOYO 配送到哪些地區？',
    'shipping.faq.where.answer': 'YCH-YOYO 服務國際客戶，可配送至結帳頁面支援的大多數地區。',
    'shipping.faq.time.question': '配送通常需要多長時間？',
    'shipping.faq.time.answer': '配送時間取決於目的地和清關進度，最終時間將在結帳後確認。',
    'shipping.faq.currency.question': '商店使用什麼貨幣？',
    'shipping.faq.currency.answer': 'ych-yoyo.com 的所有商品價格均以美元標示。',
    'notFound.seoTitle': '找不到頁面',
    'notFound.seoDescription': '您要尋找的頁面不存在。',
    'notFound.title': '404 - 找不到頁面',
    'notFound.message': '要求的頁面不存在或已移動。',
    'notFound.store': '前往商店',
  },
  fr: {
    'common.name': 'Nom',
    'common.email': 'E-mail',
    'common.password': 'Mot de passe',
    'common.role': 'Rôle',
    'common.notSet': 'Non renseigné',
    'common.loading': 'Chargement...',
    'common.refresh': 'Actualiser',
    'common.default': 'Par défaut',
    'common.quantity': 'Quantité : {{quantity}}',
    'common.price': 'Prix : {{price}}',
    'auth.login.seoDescription': 'Connectez-vous à votre compte YCH-YOYO.',
    'auth.login.intro': 'Accédez à votre compte YCH-YOYO avec votre e-mail et votre mot de passe.',
    'auth.login.submitting': 'Connexion...',
    'auth.login.error': 'Connexion impossible.',
    'auth.login.newUser': 'Vous découvrez YCH-YOYO ?',
    'auth.createAccount': 'Créer un compte',
    'auth.register.title': 'Créer un compte',
    'auth.register.seoDescription': 'Créez un compte client YCH-YOYO.',
    'auth.register.intro': 'Utilisez un e-mail et un mot de passe pour créer votre compte YCH-YOYO.',
    'auth.register.submitting': 'Création du compte...',
    'auth.register.error': 'Impossible de créer le compte.',
    'auth.register.existingUser': 'Vous avez déjà un compte ?',
    'account.seoDescription': 'Page du compte YCH-YOYO.',
    'account.loading': 'Chargement de votre compte...',
    'account.signedOutPrompt': 'Connectez-vous ou créez un compte pour accéder à votre profil YCH-YOYO et à vos commandes.',
    'account.active': 'Votre compte YCH-YOYO est actif.',
    'account.role.customer': 'Client',
    'account.role.admin': 'Administrateur',
    'account.role.unknown': 'Rôle de compte indisponible',
    'account.continueShopping': 'Continuer mes achats',
    'account.customProjects': 'Projets personnalisés',
    'account.orders.title': 'Mes commandes',
    'account.orders.intro': 'Consultez les commandes payées, les visuels de yo-yos personnalisés et le suivi des colis.',
    'account.orders.loadError': 'Impossible de charger les commandes.',
    'account.orders.empty': 'Aucune commande pour le moment.',
    'account.orderStatus.pending': 'En attente',
    'account.orderStatus.processing': 'En cours de traitement',
    'account.orderStatus.paid': 'Payée',
    'account.orderStatus.completed': 'Terminée',
    'account.orderStatus.cancelled': 'Annulée',
    'account.orderStatus.failed': 'Échouée',
    'account.orderStatus.refunded': 'Remboursée',
    'account.orderStatus.unknown': 'Statut indisponible',
    'account.orderId': 'Numéro de commande',
    'account.paid': 'Payée le : {{date}}',
    'account.country': 'Pays ou région : {{country}}',
    'account.shipment': 'Expédition',
    'account.shipment.delivered': 'Livrée',
    'account.shipment.shipped': 'Expédiée',
    'account.shipment.preparing': 'Préparation de l’envoi',
    'account.trackingNumber': 'Numéro de suivi {{carrier}}',
    'account.trackingPending': 'Nous ajouterons le numéro de suivi après l’expédition.',
    'account.trackYanwen': 'Suivre avec Yanwen',
    'account.originalArtwork': 'Visuel original',
    'account.adjustedPreview': 'Aperçu ajusté',
    'account.originalArtworkAlt': 'Visuel original du client',
    'account.adjustedPreviewAlt': 'Aperçu ajusté du yo-yo personnalisé',
    'cart.seoDescription': 'Panier de commande YCH-YOYO.',
    'cart.title': 'Votre panier',
    'cart.empty': 'Votre panier est vide.',
    'cart.artworkAfterPayment': 'L’envoi du visuel sera disponible après le paiement.',
    'cart.decreaseQuantity': 'Réduire la quantité de {{item}}',
    'cart.increaseQuantity': 'Augmenter la quantité de {{item}}',
    'cart.remove': 'Retirer',
    'cart.total': 'Total : {{total}}',
    'cart.countryLabel': 'Choisissez votre pays ou région :',
    'cart.countrySelect': 'Sélectionner',
    'cart.checkout': 'Commander',
    'cart.checkoutError': 'Échec de la commande. Veuillez réessayer.',
    'cart.unlistedCountry': 'Si votre pays ou région ne figure pas dans la liste, contactez-nous directement.',
    'cart.loginRequired': 'Connexion requise',
    'cart.loginPrompt': 'Connectez-vous ou créez un compte avant de passer commande.',
    'payment.seoDescription': 'Paiement sécurisé pour les commandes YCH-YOYO.',
    'payment.succeeded': 'Paiement réussi !',
    'payment.processing': 'Votre paiement est en cours de traitement.',
    'payment.failed': 'Le paiement a échoué. Veuillez réessayer.',
    'payment.error': 'Un problème est survenu.',
    'payment.unexpectedError': 'Une erreur inattendue est survenue.',
    'payment.payNow': 'Payer maintenant',
    'contact.title': 'Contacter YCH-YOYO',
    'contact.seoTitle': 'Nous contacter',
    'contact.seoDescription': 'Contactez YCH-YOYO pour obtenir de l’aide ou poser une question sur nos produits.',
    'contact.intro': 'Remplissez ce formulaire si vous avez besoin d’aide ou si vous avez une question.',
    'contact.firstName': 'Prénom (obligatoire)',
    'contact.lastName': 'Nom (obligatoire)',
    'contact.email': 'Adresse e-mail (obligatoire)',
    'contact.subject': 'Objet (obligatoire)',
    'contact.message': 'Message (obligatoire)',
    'contact.submit': 'Envoyer',
    'shipping.seoTitle': 'Politique de livraison',
    'shipping.seoDescription': 'Zones desservies, délais et devise des commandes YCH-YOYO.',
    'shipping.title': 'Informations de livraison',
    'shipping.intro': 'YCH-YOYO est une boutique internationale de yo-yos et livre vers la plupart des destinations proposées lors de la commande. Si votre pays ou région ne figure pas dans la liste, contactez-nous avant de commander.',
    'shipping.timingTitle': 'Délais de livraison',
    'shipping.timing': 'Les délais dépendent de la destination, des douanes et du transporteur local. Une estimation est affichée lors de la commande lorsqu’elle est disponible.',
    'shipping.carrierTitle': 'Transporteur',
    'shipping.carrier': 'Le transporteur peut varier selon la destination et le type de colis.',
    'shipping.currencyTitle': 'Devise',
    'shipping.currency': 'Tous les prix affichés sont en dollars américains.',
    'shipping.questionsTitle': 'Questions sur la politique',
    'shipping.questions': 'Pour toute question sur la livraison, les retours ou une demande particulière, utilisez le formulaire de contact.',
    'shipping.faq.where.question': 'Où YCH-YOYO livre-t-il ?',
    'shipping.faq.where.answer': 'YCH-YOYO sert une clientèle internationale et livre vers la plupart des régions proposées lors de la commande.',
    'shipping.faq.time.question': 'Combien de temps prend généralement la livraison ?',
    'shipping.faq.time.answer': 'Le délai dépend de la destination et du traitement douanier. Le calendrier définitif est confirmé après la commande.',
    'shipping.faq.currency.question': 'Quelle devise la boutique utilise-t-elle ?',
    'shipping.faq.currency.answer': 'Tous les prix des produits sur ych-yoyo.com sont indiqués en dollars américains.',
    'notFound.seoTitle': 'Page introuvable',
    'notFound.seoDescription': 'La page recherchée n’existe pas.',
    'notFound.title': '404 - Page introuvable',
    'notFound.message': 'La page demandée n’existe pas ou a été déplacée.',
    'notFound.store': 'Accéder à la boutique',
  },
  es: {
    'common.name': 'Nombre',
    'common.email': 'Correo electrónico',
    'common.password': 'Contraseña',
    'common.role': 'Rol',
    'common.notSet': 'Sin configurar',
    'common.loading': 'Cargando...',
    'common.refresh': 'Actualizar',
    'common.default': 'Predeterminado',
    'common.quantity': 'Cantidad: {{quantity}}',
    'common.price': 'Precio: {{price}}',
    'auth.login.seoDescription': 'Inicia sesión en tu cuenta de YCH-YOYO.',
    'auth.login.intro': 'Accede a tu cuenta de YCH-YOYO con tu correo electrónico y contraseña.',
    'auth.login.submitting': 'Iniciando sesión...',
    'auth.login.error': 'No se pudo iniciar sesión.',
    'auth.login.newUser': '¿Eres nuevo en YCH-YOYO?',
    'auth.createAccount': 'Crear una cuenta',
    'auth.register.title': 'Crear cuenta',
    'auth.register.seoDescription': 'Crea una cuenta de cliente de YCH-YOYO.',
    'auth.register.intro': 'Usa un correo electrónico y una contraseña para crear tu cuenta de YCH-YOYO.',
    'auth.register.submitting': 'Creando la cuenta...',
    'auth.register.error': 'No se pudo crear la cuenta.',
    'auth.register.existingUser': '¿Ya tienes una cuenta?',
    'account.seoDescription': 'Página de la cuenta de YCH-YOYO.',
    'account.loading': 'Cargando tu cuenta...',
    'account.signedOutPrompt': 'Inicia sesión o crea una cuenta para acceder a tu perfil y pedidos de YCH-YOYO.',
    'account.active': 'Tu cuenta de YCH-YOYO está activa.',
    'account.role.customer': 'Cliente',
    'account.role.admin': 'Administrador',
    'account.role.unknown': 'Rol de cuenta no disponible',
    'account.continueShopping': 'Seguir comprando',
    'account.customProjects': 'Proyectos personalizados',
    'account.orders.title': 'Mis pedidos',
    'account.orders.intro': 'Consulta pedidos pagados, diseños de yo-yos personalizados y el seguimiento del envío.',
    'account.orders.loadError': 'No se pudieron cargar los pedidos.',
    'account.orders.empty': 'Todavía no hay pedidos.',
    'account.orderStatus.pending': 'Pendiente',
    'account.orderStatus.processing': 'En proceso',
    'account.orderStatus.paid': 'Pagado',
    'account.orderStatus.completed': 'Completado',
    'account.orderStatus.cancelled': 'Cancelado',
    'account.orderStatus.failed': 'Fallido',
    'account.orderStatus.refunded': 'Reembolsado',
    'account.orderStatus.unknown': 'Estado no disponible',
    'account.orderId': 'ID del pedido',
    'account.paid': 'Pagado: {{date}}',
    'account.country': 'País o región: {{country}}',
    'account.shipment': 'Envío',
    'account.shipment.delivered': 'Entregado',
    'account.shipment.shipped': 'Enviado',
    'account.shipment.preparing': 'Preparando el envío',
    'account.trackingNumber': 'Número de seguimiento de {{carrier}}',
    'account.trackingPending': 'Actualizaremos el número de seguimiento después del envío.',
    'account.trackYanwen': 'Rastrear con Yanwen',
    'account.originalArtwork': 'Diseño original',
    'account.adjustedPreview': 'Vista previa ajustada',
    'account.originalArtworkAlt': 'Diseño original del cliente',
    'account.adjustedPreviewAlt': 'Vista previa ajustada del yo-yo personalizado',
    'cart.seoDescription': 'Carrito para pagar pedidos de YCH-YOYO.',
    'cart.title': 'Tu carrito',
    'cart.empty': 'No hay productos en el carrito.',
    'cart.artworkAfterPayment': 'Podrás subir el diseño después del pago.',
    'cart.decreaseQuantity': 'Reducir la cantidad de {{item}}',
    'cart.increaseQuantity': 'Aumentar la cantidad de {{item}}',
    'cart.remove': 'Eliminar',
    'cart.total': 'Total: {{total}}',
    'cart.countryLabel': 'Elige tu país o región:',
    'cart.countrySelect': 'Seleccionar',
    'cart.checkout': 'Finalizar compra',
    'cart.checkoutError': 'No se pudo iniciar el pago. Inténtalo de nuevo.',
    'cart.unlistedCountry': 'Si tu país o región no aparece en la lista, ponte en contacto con nosotros.',
    'cart.loginRequired': 'Debes iniciar sesión',
    'cart.loginPrompt': 'Inicia sesión o crea una cuenta antes de finalizar la compra.',
    'payment.seoDescription': 'Pago seguro para pedidos de YCH-YOYO.',
    'payment.succeeded': '¡Pago realizado!',
    'payment.processing': 'Tu pago se está procesando.',
    'payment.failed': 'El pago no se completó. Inténtalo de nuevo.',
    'payment.error': 'Se ha producido un problema.',
    'payment.unexpectedError': 'Se ha producido un error inesperado.',
    'payment.payNow': 'Pagar ahora',
    'contact.title': 'Contactar con YCH-YOYO',
    'contact.seoTitle': 'Contacto',
    'contact.seoDescription': 'Contacta con YCH-YOYO para obtener ayuda o resolver dudas sobre productos.',
    'contact.intro': 'Completa este formulario si necesitas ayuda o tienes alguna pregunta.',
    'contact.firstName': 'Nombre (obligatorio)',
    'contact.lastName': 'Apellidos (obligatorio)',
    'contact.email': 'Correo electrónico (obligatorio)',
    'contact.subject': 'Asunto (obligatorio)',
    'contact.message': 'Mensaje (obligatorio)',
    'contact.submit': 'Enviar',
    'shipping.seoTitle': 'Política de envíos',
    'shipping.seoDescription': 'Cobertura, plazos y moneda de los pedidos de YCH-YOYO.',
    'shipping.title': 'Información de envío',
    'shipping.intro': 'YCH-YOYO es una tienda internacional de yo-yos y envía a la mayoría de los destinos disponibles al finalizar la compra. Si tu país o región no aparece, ponte en contacto con nosotros antes de realizar el pedido.',
    'shipping.timingTitle': 'Plazos de entrega',
    'shipping.timing': 'El plazo depende del destino, las aduanas y el transportista local. Cuando esté disponible, se mostrará una estimación al finalizar la compra.',
    'shipping.carrierTitle': 'Transportista',
    'shipping.carrier': 'El servicio de transporte puede variar según el destino y el tipo de paquete.',
    'shipping.currencyTitle': 'Moneda',
    'shipping.currency': 'Todos los precios se muestran en dólares estadounidenses.',
    'shipping.questionsTitle': 'Preguntas sobre la política',
    'shipping.questions': 'Para consultas sobre envíos, devoluciones o requisitos especiales, utiliza el formulario de contacto.',
    'shipping.faq.where.question': '¿Dónde realiza envíos YCH-YOYO?',
    'shipping.faq.where.answer': 'YCH-YOYO atiende a clientes internacionales y envía a la mayoría de las regiones disponibles al finalizar la compra.',
    'shipping.faq.time.question': '¿Cuánto suele tardar el envío?',
    'shipping.faq.time.answer': 'El plazo varía según el destino y el proceso aduanero. El calendario definitivo se confirma después de la compra.',
    'shipping.faq.currency.question': '¿Qué moneda utiliza la tienda?',
    'shipping.faq.currency.answer': 'Todos los precios de productos en ych-yoyo.com se indican en dólares estadounidenses.',
    'notFound.seoTitle': 'Página no encontrada',
    'notFound.seoDescription': 'La página que buscas no existe.',
    'notFound.title': '404 - Página no encontrada',
    'notFound.message': 'La página solicitada no existe o se ha movido.',
    'notFound.store': 'Ir a la tienda',
  },
  ko: {
    'common.name': '이름',
    'common.email': '이메일',
    'common.password': '비밀번호',
    'common.role': '역할',
    'common.notSet': '설정되지 않음',
    'common.loading': '불러오는 중...',
    'common.refresh': '새로고침',
    'common.default': '기본',
    'common.quantity': '수량: {{quantity}}',
    'common.price': '가격: {{price}}',
    'auth.login.seoDescription': 'YCH-YOYO 계정에 로그인하세요.',
    'auth.login.intro': '이메일과 비밀번호로 YCH-YOYO 계정에 접속하세요.',
    'auth.login.submitting': '로그인 중...',
    'auth.login.error': '로그인할 수 없습니다.',
    'auth.login.newUser': 'YCH-YOYO가 처음이신가요?',
    'auth.createAccount': '계정 만들기',
    'auth.register.title': '계정 만들기',
    'auth.register.seoDescription': 'YCH-YOYO 고객 계정을 만드세요.',
    'auth.register.intro': '이메일과 비밀번호를 사용해 YCH-YOYO 계정을 만드세요.',
    'auth.register.submitting': '계정 생성 중...',
    'auth.register.error': '계정을 만들 수 없습니다.',
    'auth.register.existingUser': '이미 계정이 있으신가요?',
    'account.seoDescription': 'YCH-YOYO 계정 페이지입니다.',
    'account.loading': '계정을 불러오는 중...',
    'account.signedOutPrompt': '로그인하거나 계정을 만들어 YCH-YOYO 프로필과 주문을 확인하세요.',
    'account.active': 'YCH-YOYO 계정이 활성화되었습니다.',
    'account.role.customer': '고객',
    'account.role.admin': '관리자',
    'account.role.unknown': '계정 역할을 확인할 수 없음',
    'account.continueShopping': '쇼핑 계속하기',
    'account.customProjects': '맞춤 프로젝트',
    'account.orders.title': '내 주문',
    'account.orders.intro': '결제된 주문, 커스텀 요요 아트워크, 배송 추적을 확인하세요.',
    'account.orders.loadError': '주문을 불러올 수 없습니다.',
    'account.orders.empty': '아직 주문이 없습니다.',
    'account.orderStatus.pending': '대기 중',
    'account.orderStatus.processing': '처리 중',
    'account.orderStatus.paid': '결제 완료',
    'account.orderStatus.completed': '완료',
    'account.orderStatus.cancelled': '취소됨',
    'account.orderStatus.failed': '실패',
    'account.orderStatus.refunded': '환불됨',
    'account.orderStatus.unknown': '상태를 확인할 수 없음',
    'account.orderId': '주문 ID',
    'account.paid': '결제 일시: {{date}}',
    'account.country': '국가 또는 지역: {{country}}',
    'account.shipment': '배송',
    'account.shipment.delivered': '배송 완료',
    'account.shipment.shipped': '발송 완료',
    'account.shipment.preparing': '배송 준비 중',
    'account.trackingNumber': '{{carrier}} 운송장 번호',
    'account.trackingPending': '발송 후 운송장 번호를 업데이트합니다.',
    'account.trackYanwen': 'Yanwen에서 추적',
    'account.originalArtwork': '원본 아트워크',
    'account.adjustedPreview': '조정된 미리보기',
    'account.originalArtworkAlt': '고객 원본 아트워크',
    'account.adjustedPreviewAlt': '조정된 커스텀 요요 미리보기',
    'cart.seoDescription': 'YCH-YOYO 결제용 장바구니입니다.',
    'cart.title': '장바구니',
    'cart.empty': '장바구니에 상품이 없습니다.',
    'cart.artworkAfterPayment': '결제 후 아트워크를 업로드할 수 있습니다.',
    'cart.decreaseQuantity': '{{item}} 수량 줄이기',
    'cart.increaseQuantity': '{{item}} 수량 늘리기',
    'cart.remove': '삭제',
    'cart.total': '합계: {{total}}',
    'cart.countryLabel': '국가 또는 지역 선택:',
    'cart.countrySelect': '선택',
    'cart.checkout': '결제하기',
    'cart.checkoutError': '결제를 시작하지 못했습니다. 다시 시도해 주세요.',
    'cart.unlistedCountry': '국가 또는 지역이 목록에 없으면 직접 문의해 주세요.',
    'cart.loginRequired': '로그인이 필요합니다',
    'cart.loginPrompt': '결제하기 전에 로그인하거나 계정을 만들어 주세요.',
    'payment.seoDescription': 'YCH-YOYO 주문을 위한 안전한 결제 페이지입니다.',
    'payment.succeeded': '결제가 완료되었습니다!',
    'payment.processing': '결제를 처리 중입니다.',
    'payment.failed': '결제가 완료되지 않았습니다. 다시 시도해 주세요.',
    'payment.error': '문제가 발생했습니다.',
    'payment.unexpectedError': '예기치 않은 오류가 발생했습니다.',
    'payment.payNow': '지금 결제',
    'contact.title': 'YCH-YOYO 문의',
    'contact.seoTitle': '문의하기',
    'contact.seoDescription': '지원, 제품 및 일반 문의는 YCH-YOYO로 연락해 주세요.',
    'contact.intro': '도움이 필요하거나 궁금한 점이 있으면 이 양식을 작성해 주세요.',
    'contact.firstName': '이름 (필수)',
    'contact.lastName': '성 (필수)',
    'contact.email': '이메일 주소 (필수)',
    'contact.subject': '제목 (필수)',
    'contact.message': '메시지 (필수)',
    'contact.submit': '보내기',
    'shipping.seoTitle': '배송 정책',
    'shipping.seoDescription': 'YCH-YOYO 주문의 배송 지역, 배송 기간 및 통화 안내입니다.',
    'shipping.title': '배송 정보',
    'shipping.intro': 'YCH-YOYO는 전 세계 고객을 위한 요요 스토어이며 결제 시 선택 가능한 대부분의 지역으로 배송합니다. 국가 또는 지역이 목록에 없으면 주문 전에 문의해 주세요.',
    'shipping.timingTitle': '배송 기간',
    'shipping.timing': '배송 기간은 목적지, 통관 및 현지 배송업체에 따라 달라집니다. 가능한 경우 결제 시 예상 기간이 표시됩니다.',
    'shipping.carrierTitle': '배송업체',
    'shipping.carrier': '배송업체는 목적지와 소포 유형에 따라 달라질 수 있습니다.',
    'shipping.currencyTitle': '통화',
    'shipping.currency': '표시된 모든 상품 가격은 미국 달러입니다.',
    'shipping.questionsTitle': '정책 문의',
    'shipping.questions': '배송, 반품 또는 특별 취급 요청은 문의 양식을 이용해 주세요.',
    'shipping.faq.where.question': 'YCH-YOYO는 어디로 배송하나요?',
    'shipping.faq.where.answer': 'YCH-YOYO는 해외 고객에게 서비스를 제공하며 결제 시 선택 가능한 대부분의 지역으로 배송합니다.',
    'shipping.faq.time.question': '배송은 보통 얼마나 걸리나요?',
    'shipping.faq.time.answer': '배송 기간은 목적지와 통관 처리에 따라 달라집니다. 최종 일정은 결제 후 확정됩니다.',
    'shipping.faq.currency.question': '스토어에서 어떤 통화를 사용하나요?',
    'shipping.faq.currency.answer': 'ych-yoyo.com의 모든 상품 가격은 미국 달러로 표시됩니다.',
    'notFound.seoTitle': '페이지를 찾을 수 없습니다',
    'notFound.seoDescription': '요청한 페이지가 존재하지 않습니다.',
    'notFound.title': '404 - 페이지를 찾을 수 없습니다',
    'notFound.message': '요청한 페이지가 없거나 이동되었습니다.',
    'notFound.store': '스토어로 이동',
  },
};
